import { render, staticRenderFns } from "./daiban.vue?vue&type=template&id=4e9742f7&scoped=true&"
import script from "./daiban.vue?vue&type=script&lang=js&"
export * from "./daiban.vue?vue&type=script&lang=js&"
import style0 from "./daiban.vue?vue&type=style&index=0&id=4e9742f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9742f7",
  null
  
)

export default component.exports